class HoverZoom {
  constructor() {
    this.init();
  }

  init() {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => this.setup());
    } else {
      this.setup();
    }
    document.addEventListener('shopify:section:load', () => this.setup());
  }

  setup() {
    const galleries = document.querySelectorAll('media-gallery');
    galleries.forEach(gallery => this.attachToGallery(gallery));
  }

  attachToGallery(gallery) {
    if (gallery.dataset.hoverZoomInit) return;
    gallery.dataset.hoverZoomInit = 'true';

    const mediaColumn = gallery.closest('.product-information__media');
    if (!mediaColumn) return;

    const productGrid = mediaColumn.closest('product-component');
    if (!productGrid) return;

    // Crear el panel de zoom
    const zoomPanel = document.createElement('div');
    zoomPanel.className = 'hover-zoom-panel';
    zoomPanel.innerHTML = '<div class="hover-zoom-panel__inner"><img class="hover-zoom-panel__img" alt="" /></div>';

    // Insertar en el body para no afectar el grid
    document.body.appendChild(zoomPanel);

    const zoomImg = zoomPanel.querySelector('.hover-zoom-panel__img');

    gallery.addEventListener('mousemove', (e) => {
      const mediaItem = e.target.closest('.product-media-container--image');
      if (!mediaItem) {
        zoomPanel.classList.remove('hover-zoom-panel--active');
        return;
      }

      const img = mediaItem.querySelector('img.product-media__image');
      if (!img) return;

      const highResSrc = img.getAttribute('data_max_resolution') || img.src;

      if (zoomImg.dataset.src !== highResSrc) {
        zoomImg.dataset.src = highResSrc;
        zoomImg.src = highResSrc;
      }

      const rect = mediaItem.getBoundingClientRect();
      const xPct = ((e.clientX - rect.left) / rect.width) * 100;
      const yPct = ((e.clientY - rect.top) / rect.height) * 100;

      zoomImg.style.transformOrigin = `${xPct}% ${yPct}%`;
      zoomPanel.classList.add('hover-zoom-panel--active');
    });

    gallery.addEventListener('mouseleave', () => {
      zoomPanel.classList.remove('hover-zoom-panel--active');
    });
  }
}

new HoverZoom();
